<template>
  <div class="account-icon" :style="accountIconStyle">
    <img :src="iconImageUrl" alt="account icon" />
  </div>
</template>
<script>
import NoneImage from '../../../../../../src/images/styleguide/none.png'
export default {
  props: {
    imageUrl: {
      type: String,
      required: false,
      default: ''
    },
    size: {
      type: Number,
      required: true
    }
  },
  computed: {
    isEmptyImageUrl() {
      return !this.imageUrl || this.imageUrl.length === 0
    },
    iconImageUrl() {
      return this.isEmptyImageUrl ? NoneImage : this.imageUrl
    },
    accountIconStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        'min-width': `${this.size}px`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.account-icon {
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;

  img {
    width: 100%;
    object-fit: cover;
  }
}
</style>
